export const mockData = {
  services: [
    {
      icon: 'Code2',
      title: 'Custom WebApps',
      description: 'Maßgeschneiderte Webanwendungen, die exakt auf Ihre Geschäftsprozesse zugeschnitten sind. Von der Planung bis zur Umsetzung – wir entwickeln die perfekte Lösung für Ihr Unternehmen.'
    },
    {
      icon: 'Smartphone',
      title: 'Mobile-First Design',
      description: 'Responsive Anwendungen, die auf allen Geräten perfekt funktionieren. Ihre Kunden erreichen Sie überall – egal ob Desktop, Tablet oder Smartphone.'
    },
    {
      icon: 'Zap',
      title: 'Prozessoptimierung',
      description: 'Automatisieren Sie wiederkehrende Aufgaben und optimieren Sie Ihre Arbeitsabläufe. Wir analysieren Ihre Prozesse und entwickeln intelligente Lösungen zur Effizienzsteigerung.'
    },
    {
      icon: 'Users',
      title: 'Handwerksbetriebe',
      description: 'Spezielle Lösungen für Handwerksbetriebe: Werkzeugverwaltung, Fahrzeugtracking, Auftragsverwaltung und mehr. Digital durchstarten mit AppPilot.'
    },
    {
      icon: 'Shield',
      title: 'Datenschutz & Sicherheit',
      description: 'DSGVO-konform und sicher. Alle Daten werden ausschließlich auf Servern in Deutschland gespeichert. Ihre Sicherheit hat bei uns höchste Priorität.'
    },
    {
      icon: 'Server',
      title: 'Wartung & Support',
      description: 'Auch nach dem Launch sind wir für Sie da. Regelmäßige Updates, technischer Support und kontinuierliche Optimierung – wir sorgen für den reibungslosen Betrieb Ihrer Anwendung.'
    }
  ],
  features: [
    {
      icon: 'Shield',
      title: 'DSGVO-konform',
      description: 'Höchste Datenschutzstandards und vollständige DSGVO-Konformität. Ihre Daten sind bei uns in sicheren Händen.'
    },
    {
      icon: 'Server',
      title: 'Server in EU/Deutschland',
      description: 'Server-Standorte in der EU. Auf Wunsch ausschließlich in Deutschland. Keine Datenübertragung außerhalb der EU, volle Kontrolle über Ihre Daten.'
    },
    {
      icon: 'Zap',
      title: 'Schnelle Umsetzung',
      description: 'Effiziente Entwicklungsprozesse bedeuten kurze Projektlaufzeiten. Von der Idee zur fertigen Anwendung in kürzester Zeit.'
    },
    {
      icon: 'CheckCircle2',
      title: 'Kostengünstig',
      description: 'Faire Preise für kleine und mittelständische Unternehmen. Transparente Kostenstruktur ohne versteckte Gebühren.'
    }
  ],
  portfolio: [
    {
      title: 'Memoryo - Digitales Gästebuch',
      description: 'Innovative Web-App zum Sammeln von Fotos und Nachrichten bei Events. QR-Code teilen, Erinnerungen live empfangen und in einer wunderschönen Timeline bewahren. Mit Live-Slideshow für Beamer.',
      image: '/images/portfolio-memoryo.jpg',
      tags: ['Web-App', 'Events', 'SaaS'],
      link: 'https://memoryo.app'
    },
    {
      title: 'Geile Kiste - Fotobox-Verleih',
      description: 'Moderner Fotobox-Verleih am Bodensee. Website mit Preisübersicht, Online-Anfrage und reCAPTCHA-geschütztem Kontaktformular. Für Hochzeiten, Geburtstage und Firmenevents.',
      image: '/images/portfolio-geilekiste.jpg',
      tags: ['Website', 'Events', 'Buchung'],
      link: 'https://geile-kiste.com'
    },
    {
      title: "Stevie's Original - Mobile Bar",
      description: 'Elegante Website für einen mobilen Barservice am Bodensee. Stilvoller Barwagen aus einem restaurierten Pferdeanhänger (Bj. 1986) für Hochzeiten, Firmenevents und besondere Anlässe.',
      image: '/images/portfolio-steviesbar.jpg',
      tags: ['Website', 'Events', 'Gastronomie'],
      link: 'https://www.steviesbar.de'
    },
    {
      title: 'Marktgarten Roots',
      description: 'Professionelle Website für regenerativen Gemüsebau im Allgäu. Abo-Kisten, Gastronomie-Belieferung und Schnittblumen. Responsive Design mit Online-Bestellung.',
      image: '/images/portfolio-marktgarten.jpg',
      tags: ['Website', 'E-Commerce', 'Regional'],
      link: 'https://marktgarten-roots.de'
    },
    {
      title: 'Petri - Dein Fangbuch',
      description: 'iOS App für Angler zum Dokumentieren ihrer Fänge. Moderne App mit Foto-Upload, Wetterinfo, Statistiken und persönlichem Fangbuch. Im App Store verfügbar!',
      image: '/images/portfolio-petri.jpg',
      tags: ['iOS App', 'Mobile', 'Outdoor'],
      link: 'https://apps.apple.com/de/app/petri-dein-fangbuch/id6760222198'
    }
  ]
};